<ng-container *ngIf="!(loading$ | async); else loader">
  <div
    (click)="$event.stopPropagation()"
    class="notes-list"
    data-cy="notes-list"
    [ngClass]="{'scrollable': !fullpage}"
  >
    <div *ngIf="notes.length > 0">
      <ng-container *ngIf="(isDeletingNote$ | async) === false; else loader">
        <div
          *ngFor="let item of notes"
          class="notes-items"
        >
          <mojo-notes-item
            data-cy="mojo-notes-item"
            *ngIf="
          (item.note.category !== draft) ||
          (
            item.user === (loggedIn$ | async) &&
            (item.note.category === draft || !item.note.isPublic)
          )"
            [author]="item.user"
            [note]="item.note"
            [fullpage]="fullpage"
            [sideDrawerConfiguration]="sideDrawerConfiguration"
            (openEdit)="openEditModal($event)"
          >
          </mojo-notes-item>
        </div>
      </ng-container>
    </div>
  </div>
  <span
    *ngIf="notes.length === 0"
    class="no-notes"
    [ngClass]="{'side-drawer-no-notes': !!sideDrawerConfiguration, 'padding-page': !sideDrawerConfiguration}"
  >
    No notes added yet. Add the first one!
  </span>

  <div
    *ngIf="fullpage"
    data-cy="notes-list-pagination"
    class="pagination-container"
  >
    <mojo-pagination
      (pageChange)="setPageNumber($event)"
      [pagination]="pagination$ | async"
    >
    </mojo-pagination>
  </div>
</ng-container>

<ng-template #loader>
  <div class="loader">
    <mojo-loader></mojo-loader>
  </div>
</ng-template>
